<!-- 护理人员配置 -->
<template>
  <div class="main" style="width: 1180px;">
    <a-card>
      <a-tabs v-model="key" @change="callback">
        <a-tab-pane key="1" tab="监测仪录入">
          <radarMonitorDeploy></radarMonitorDeploy>
        </a-tab-pane>
        <a-tab-pane key="4" tab="监测仪位置管理">
          <radarPosition></radarPosition>
        </a-tab-pane>
        <a-tab-pane key="2" tab="监测仪工作配置">
          <radarWorkDeploy></radarWorkDeploy>
        </a-tab-pane>
        <!-- <a-tab-pane key="3" tab="监测仪监测默认配置">
          <radarBedDeploy></radarBedDeploy>
        </a-tab-pane> -->
        <a-tab-pane key="3" tab="监测仪工作情况">
          <radarWorkingDeploy></radarWorkingDeploy>
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </div>
</template>

<script>
import radarMonitorDeploy from "./radarMonitorDeploy";
import radarWorkDeploy from "./radarWorkDeploy";
import radarBedDeploy from "./radarBedDeploy";
import radarWorkingDeploy from "./radarWorkingDeploy";
import radarPosition from "./radarPosition";
export default {
  components: {
    radarMonitorDeploy,
    radarWorkDeploy,
    radarBedDeploy,
    radarWorkingDeploy,
    radarPosition
  },
  data() {
    return {
      key: "1" || localStorage.getItem("key"),
    };
  },
  created() {},
  mounted() {
    this.key = localStorage.getItem("key") ? localStorage.getItem("key") : "1";
  },
  methods: {
    // 监听切换
    callback(e) {
      console.log(e);
      localStorage.setItem("key", e);
    },
  },
};
</script>
<style lang="scss" scoped>
.main::v-deep {
  padding: 20px 0;
  .ant-card {
    padding: 15px 20px;
    border-radius: 8px;
    .ant-card-body {
      padding: 0;
    }
  }
  .ant-tabs-bar {
    border-bottom: none;
  }
}
</style>
